export default __webpack_public_path__ + "static/media/ScraWebsiteThumbnail.7f5e98e7.jpg";